import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { FileSizeModule } from '@fi-shared/media-bank/file-size/file-size.module';
import { FiMediaBankDownloadDialogComponent } from './fi-media-bank-download-dialog.component';

@NgModule({
    imports: [CommonModule, MatListModule, FileSizeModule],
    declarations: [FiMediaBankDownloadDialogComponent],
    exports: [FiMediaBankDownloadDialogComponent],
})
export class FiMediaBankDownloadDialogModule {}
